
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import BaseVue from '@/components/BaseVue';
    import { handleSearchStation } from '../scripts/SearchEkitan';

    @Component
    export default class StationTextField extends BaseVue {

        @Prop({}) readonly text!: string;
        @Prop({}) readonly cd!: string;
        @Prop() readonly busOption!: number;
        @Prop() readonly taregetDate!: string;
        @Prop({ required: true }) readonly label!: string;

        //#region
        private suggestStationList: { text: string, cd: string, message: string }[] = [];
        private showSuggestStationList = false;
        private focusedIndex: number = -1;

        private showMessage = false;
        private messageType = 'info';
        private message = '';
        private isFocused = false;

        private station = { text: this.text, cd: this.cd };

        //#endregion

        //#region ウォッチャー（親コンポーネントの入力値）
        @Watch('text', { immediate: true, deep: true })
        onTextChanged(newValue: string) {

            this.station.text = newValue;

            //値がないもの、または空白のものはnullとして返却
            if (newValue === null ) {
                this.$emit('update:text', null);
                this.$emit('update:cd', null);
            } else if ((newValue || '').trim() === '') {
                this.$emit('update:text', null);
                this.$emit('update:cd', null);
            }
        }

        @Watch('cd', { immediate: true, deep: true })
        onCdChanged(newValue: string) {
            this.station.cd = newValue;
        }
        //#endregion

        //#region　イベント

        //#region フォーカス
        private onFocus() {
            this.isFocused = true;
            if (!this.isNullOrEmpty(this.station.text)) {
                this.searchSuggestStation();
            }
        }
        //#endregion

        //#region　ロストフォーカス
        private onBlur() {
            this.isFocused = false;
            this.initSuggestStationList();
        }
        //#endregion

        //#region 予測駅リストを取得・表示する
        private async searchSuggestStation() {

            this.showMessage = false;
            this.station.cd = '';

            //駅名が入力されている場合のみ取得する
            if (this.station.text.length > 0) {

                //候補を取得
                this.suggestStationList = await handleSearchStation(this.station.text, this.busOption, this.taregetDate);

                if (this.suggestStationList.length > 0) {
                    //取得結果　有の場合
                    if (this.openAPImessage(this.suggestStationList[0].message)) {
                        //取得処理中にエラー発生時

                        //初期化
                        this.suggestStationList = [];
                        return;
                    }
                    //入力値を親コンポーネントに反映
                    this.$emit('update:text', this.station.text);
                    this.$emit('update:cd', null);
                    //候補リストを表示
                    if (this.station.text && this.isFocused) {
                        this.showSuggestStationList = true;
                    }
                    else {
                        this.initSuggestStationList();
                    }
                    //候補リストの先頭を選択状態にする
                    this.focusedIndex = 0;
                } else {
                    this.initSuggestStationList();
                    this.$emit('update:text', this.station.text);
                    this.$emit('update:cd', null);
                }
            } else {
                //駅名入力なし（削除された）場合、初期化処理
                this.initSuggestStationList();
                this.$emit('update:text', this.station.text);
                this.$emit('update:cd', null);
            }
        }
        //#endregion

        //#region　予測駅　選択（マウス操作）
        private selectSuggestStation(suggestStation: any) {
            //エラーメッセージ表示中の場合、非表示
            this.showMessage = false;

            //選択駅の駅名と駅コードを親コンポーネントへ反映
            this.station.text = suggestStation.text;
            this.station.cd = suggestStation.cd;
            this.$emit('update:text', this.station.text);
            this.$emit('update:cd', this.station.cd);

            //駅候補リストを初期化
            this.initSuggestStationList();
        }
        //#endregion

        //#region　予測駅　選択（キー操作）
        private selectStation() {
            if (this.focusedIndex >= 0 && this.focusedIndex < this.suggestStationList.length) {
                //選択状態の駅が存在する場合

                //選択状態の駅の駅名と駅コードを親コンポーネントへ反映
                this.station.text = this.suggestStationList[this.focusedIndex].text;
                this.station.cd = this.suggestStationList[this.focusedIndex].cd;
                this.$emit('update:text', this.station.text);
                this.$emit('update:cd', this.station.cd);

                //駅候補リストを初期化
                this.initSuggestStationList();
            }
        }
        //#endregion

        //#region　選択状態を移動（矢印キー）
        private moveFocus(direction: number) {
            if (this.suggestStationList.length === 0) return;

            //候補駅が存在する場合
            this.focusedIndex = (this.focusedIndex + direction + this.suggestStationList.length) % this.suggestStationList.length;
            this.$nextTick(() => {
                const focusedElement = this.$el.querySelector('.focused') as HTMLElement;
                if (focusedElement) {
                    //選択状態の駅へスクロールを移動
                    focusedElement.scrollIntoView({ block: 'nearest', inline: 'nearest' });
                }
            });
        }
        //#endregion

        //#endregion

        //#region プライベートメソッド

        //#region
        private isNullOrEmpty(value: string | null): boolean {
            //値がないもの、または空白のものはnullとして返却
            if (value === null) {
                return true;
            } else if ((value || '').trim() === '') {
                return true;
            }
            return false;
        }
        //#endregion

        //#region　候補リストを初期化する
        private initSuggestStationList() {

            //リスト非表示
            this.showSuggestStationList = false;
            //リストを初期化
            this.suggestStationList = [];

        }
        //#endregion

        //#region API取得処理中のエラーを確認する
        private openAPImessage(message: string): boolean {
            if (message) {
                //メッセージあり（エラー発生）の場合
                //エラーメッセージを表示
                this.showMessage = true;
                this.message = message;
                this.messageType = 'error';
                return true;
            }
            return false;
        }
        //#endregion

        //#endregion
    }
